import React from "react";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "../../../components/ui/resizable";

interface ResizableSplitViewProps {
  tableContent: React.ReactNode;
  rightContent: React.ReactNode;
  defaultLeftSize?: number;
  defaultRightSize?: number;
}

const ResizableSplitView: React.FC<ResizableSplitViewProps> = ({
  tableContent,
  rightContent,
  defaultLeftSize = 50,
  defaultRightSize = 50,
}) => {
  return (
    <ResizablePanelGroup direction="horizontal" className="h-full w-full">
      <ResizablePanel defaultSize={defaultLeftSize} minSize={30}>
        <div className="h-full overflow-y-auto">
          <div className="p-6">{tableContent}</div>
        </div>
      </ResizablePanel>
      <ResizableHandle />
      <ResizablePanel defaultSize={defaultRightSize}>
        <div className="h-full overflow-hidden">{rightContent}</div>
      </ResizablePanel>
    </ResizablePanelGroup>
  );
};

export default ResizableSplitView;
